<template>
	<div class="laboratory_editor">
		<!-- 添加搜索替换工具栏 -->
		<div v-if="true" class="search-replace-toolbar">
			<div class="search-replace-container">
				<input
					v-model="searchReplace.searchTerm"
					placeholder="搜索内容"
					class="search-input"
					@keyup.enter="searchInContent"
				/>
				<input
					v-model="searchReplace.replaceTerm"
					placeholder="替换内容"
					class="replace-input"
				/>
				<div class="search-buttons">
					<button @click="searchInContent" class="search-btn">搜索</button>
					<button
						@click="prevMatch"
						class="nav-btn"
						:disabled="searchReplace.matches.length === 0"
						>↑</button
					>
					<button
						@click="nextMatch"
						class="nav-btn"
						:disabled="searchReplace.matches.length === 0"
						>↓</button
					>
					<span v-if="searchReplace.matches.length > 0" class="match-count">
						{{ searchReplace.currentMatchIndex + 1 }}/{{
							searchReplace.matches.length
						}}
					</span>
					<button @click="replaceCurrent" class="replace-btn">替换</button>
					<button @click="replaceAll" class="replace-all-btn">全部替换</button>
					<button @click="clearSearch" class="clear-btn">清除</button>
				</div>
			</div>
		</div>
		<el-upload
			id="upimg"
			v-show="false"
			class="upload-demo"
			:disabled="$route.query.type == 'detail'"
			action="/upload"
			:before-upload="beforeUpload"
			multiple
		>
			<el-button size="small" type="primary">点击上传</el-button>
		</el-upload>
		<quill-editor
			:options="editorOption"
			class="ql-editor"
			ref="QuillEditor"
			v-model="htmlStr"
			@blur="onEditorBlur($event)"
			@focus="onEditorFocus($event)"
			@ready="onEditorReady($event)"
			@change="onEditorChange($event)"
		/>
	</div>
</template>

<script>
import axios from "axios";
import { fixHeadingBlocks } from "@/utils/editorUtils";

import Quill from "quill";
import VueQuillEditor from "vue-quill-editor";
import imageResize from "quill-image-resize-module"; // 图片缩放组件引用
Quill.register("modules/imageResize", imageResize);

import "quill/dist/quill.core.css"; // import stylesheet for quill editor
import "quill/dist/quill.core.js"; // import stylesheet for quill editor
import "quill/dist/quill.snow.css"; // import stylesheet for snow theme (optional)
import "quill/dist/quill.bubble.css"; // import stylesheet for bubble theme (optional)

// 自定义字号的大小
var sizes = ["14px", "16px", "18px", "20px", "22px", "26px", "28px", "30px"];
var Size = Quill.import("attributors/style/size");
Size.whitelist = sizes;
Quill.register(Size, true);

const toolbarOptions = [
	["bold", "italic", "underline", "strike"],
	["blockquote"],

	[{ header: 1 }, { header: 2 }],
	[{ list: "ordered" }, { list: "bullet" }],
	[{ indent: "-1" }, { indent: "+1" }],

	[{ size: Size.whitelist }], // 配置字号
	[{ header: [1, 2, 3, 4, 5, 6, false] }],

	[{ color: [] }, { background: [] }],
	[{ align: [] }],
	["link", "image", "video"],
	["clean"],
];

export default {
	components: {
		VueQuillEditor,
	},
	props: { content: "", multiple: false, maxImageSizeMb: { type: Number, default: 0 } },

	data() {
		return {
			htmlStr: this.content,
			//参数
			cropperModel: false,
			cropperName: "",
			scale: "0",
			// ...现有数据
			searchReplace: {
				show: false,
				searchTerm: "",
				replaceTerm: "",
				matches: [],
				currentMatchIndex: -1,
			},
			editorOption: {
				theme: "snow",
				placeholder: "输入内容...",
				imageResize: true, // 开启图片调整大小功能
				modules: {
					imageResize: {
						//放大缩小
						displayStyles: {
							backgroundColor: "black",
							border: "none",
							color: "white",
						},
						modules: ["Resize", "DisplaySize", "Toolbar"],
					},
					toolbar: {
						container: toolbarOptions, // 工具栏
						handlers: {
							image: function (value) {
								if (value) {
									// 调用element的图片上传组件
									// （这里是用的原生js的选择dom方法）
									document.querySelector("#upimg button").click();
									// this.uploadPicture("");
								} else {
									this.quill.format("image", false);
								}
							}, // 添加email链接处理函数
							link: function (value) {
								if (value) {
									const href = prompt(
										"请输入链接地址 (可以是http链接或邮箱地址)"
									);
									if (href) {
										// 检查是否是邮箱地址
										const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(href);
										const linkHref = isEmail ? `mailto:${href}` : href;

										const range = this.quill.getSelection();
										if (range) {
											this.quill.format("link", linkHref);
										}
									}
								} else {
									this.quill.format("link", false);
								}
							},
						},
					},
				},
			},
		};
	},
	mounted() {
		// 设置默认字体大小为18px
		this.$nextTick(() => {
			if (this.$refs.QuillEditor && this.$refs.QuillEditor.quill) {
				const quill = this.$refs.QuillEditor.quill;

				// 设置默认字体大小
				quill.format("size", "18px");

				// 添加输入法状态标记
				let isComposing = false;

				// 监听输入法组合事件
				quill.root.addEventListener("compositionstart", () => {
					isComposing = true;
				});

				quill.root.addEventListener("compositionend", () => {
					isComposing = false;
				});

				// 监听编辑器文本变化，确保新输入的文本也使用默认字体大小
				quill.on("text-change", (delta, oldDelta, source) => {
					// 只在非输入法组合过程中处理格式设置
					if (source === "user" && !isComposing) {
						// 只处理插入操作，不处理删除操作
						if (
							delta.ops.length === 2 &&
							delta.ops[0].retain !== undefined &&
							delta.ops[1].insert !== undefined
						) {
							const insertOp = delta.ops[1];
							// 只有当插入的是文本内容时才设置字号
							if (
								typeof insertOp.insert === "string" &&
								insertOp.insert.trim().length > 0
							) {
								const position = delta.ops[0].retain;
								const length = insertOp.insert.length;

								// 检查这部分文本是否已经有字号设置
								const format = quill.getFormat(position, length);
								if (!format.size) {
									// 为新插入的文本设置默认字号
									quill.formatText(position, length, "size", "18px", "user");
								}
							}
						} else if (
							delta.ops.length === 1 &&
							delta.ops[0].insert !== undefined
						) {
							// 处理在开头插入的情况
							const insertOp = delta.ops[0];
							if (
								typeof insertOp.insert === "string" &&
								insertOp.insert.trim().length > 0
							) {
								const length = insertOp.insert.length;
								const format = quill.getFormat(0, length);
								if (!format.size) {
									quill.formatText(0, length, "size", "18px", "user");
								}
							}
						}
					}
				});
			}
		});
	},
	watch: {
		content: {
			handler(newVal) {
				if (newVal !== this.htmlStr) {
					// 加载内容时也修复标题块
					const fixedContent = fixHeadingBlocks(newVal); // 使用导入的 fixHeadingBlocks 方法
					this.htmlStr = fixedContent;

					// 如果需要更新编辑器内容
					this.$nextTick(() => {
						if (this.$refs.QuillEditor && this.$refs.QuillEditor.quill) {
							// 可以选择是否需要手动更新编辑器内容
							// this.$refs.QuillEditor.quill.pasteHTML(newVal);
						}
					});
				}
			},
			immediate: true, // 立即执行
		},
	},
	methods: {
		// 上传切图前调用
		beforeUpload(file) {
			if (this.maxImageSizeMb > 0 && file.size > this.maxImageSizeMb * 1024 * 1024) {
				this.$message.error(`正文图片单张不能超过 ${this.maxImageSizeMb}MB`);
				return false;
			}
			// 直接上传原图文件
			this.uploadOriginalImage(file);
			return false; // 阻止默认上传行为
		},
		// 直接上传原图文件
		async uploadOriginalImage(file) {
			try {
				const formData = new FormData();
				formData.append("file", file, file.name);

				console.log(
					"上传原图文件大小：",
					(file.size / (1024 * 1024)).toFixed(2),
					"MB"
				);

				const response = await axios.post(
					"https://api.me.news/upload",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);

				const res = response.data;

				if (res.code === 200) {
					const newStr = res.data.url;
					const data = { url: newStr };
					this.handleSuccess(data);
				} else {
					this.$message.error(res.message);
				}
			} catch (error) {
				this.$message.error("上传失败：" + error.message);
			}
		},

		// 修改 handleSuccess 方法以正确处理直接上传的结果
		handleSuccess(data) {
			// 获取富文本组件实例
			let quill = this.$refs.QuillEditor.quill;
			if (data && data.url) {
				// 如果上传成功
				// 获取光标所在位置
				let length = 0;
				if (quill.getSelection() && quill.getSelection().index) {
					length = quill.getSelection().index;
				} else {
					length = 0;
				}
				// 插入图片，使用服务器返回的图片链接地址
				quill.insertEmbed(length, "image", data.url);
				// 调整光标到最后
				quill.setSelection(length + 1);
			} else {
				// 提示信息
				this.$message.error("图片插入失败");
			}
		},

		// 准备富文本编辑器
		onEditorReady(quill) {
			// console.log("editor ready!", quill);
		},
		//失去焦点事件
		onEditorBlur(quill) {
			// console.log("editor blur!", quill);
		},
		//获得焦点事件
		onEditorFocus(quill) {
			// console.log("editor focus!", quill);
		},
		//内容改变事件
		onEditorChange({ quill, html, text }) {
			// console.log("editor change!", html);
			// let newStr = html.replace(
			// 	/><br><\/p>/g,
			// 	'><span style="font-size: 18px;"> </span></p>'
			// );
			// this.htmlStr = newStr;

			this.$emit("onEditorChange", { quill, html, text });
		},
		// 显示搜索替换工具栏
		toggleSearchReplace() {
			this.searchReplace.show = !this.searchReplace.show;
		},

		// 搜索功能
		searchInContent() {
			if (!this.searchReplace.searchTerm) {
				this.clearSearchHighlight();
				return;
			}

			const quill = this.$refs.QuillEditor.quill;
			const text = quill.getText();

			this.searchReplace.matches = [];
			this.searchReplace.currentMatchIndex = -1;

			// 清除之前的高亮
			this.clearSearchHighlight();

			// 查找所有匹配项
			let startIndex = 0;
			while (startIndex < text.length) {
				const index = text.indexOf(this.searchReplace.searchTerm, startIndex);
				if (index === -1) break;

				this.searchReplace.matches.push({
					index: index,
					length: this.searchReplace.searchTerm.length,
				});

				startIndex = index + this.searchReplace.searchTerm.length;
			}

			// 高亮显示所有匹配项
			this.highlightMatches();

			// 跳转到第一个匹配项
			if (this.searchReplace.matches.length > 0) {
				this.searchReplace.currentMatchIndex = 0;
				this.focusMatch(0);
			}
		},

		// 高亮所有匹配项
		highlightMatches() {
			const quill = this.$refs.QuillEditor.quill;
			this.searchReplace.matches.forEach((match, index) => {
				const bgColor =
					index === this.searchReplace.currentMatchIndex
						? "#ff9900"
						: "#ffff00";
				quill.formatText(match.index, match.length, "background", bgColor);
			});
		},

		// 跳转到指定匹配项
		focusMatch(index) {
			if (this.searchReplace.matches.length === 0) return;

			const quill = this.$refs.QuillEditor.quill;
			const match = this.searchReplace.matches[index];

			// 更新当前匹配项索引
			this.searchReplace.currentMatchIndex = index;

			// 重新高亮（当前项使用不同颜色）
			this.clearSearchHighlight();
			this.highlightMatches();

			// 滚动到匹配项
			quill.setSelection(match.index, match.length);
		},

		// 下一个匹配项
		nextMatch() {
			if (this.searchReplace.matches.length === 0) return;

			let nextIndex = this.searchReplace.currentMatchIndex + 1;
			if (nextIndex >= this.searchReplace.matches.length) {
				nextIndex = 0; // 循环到第一个
			}

			this.focusMatch(nextIndex);
		},

		// 上一个匹配项
		prevMatch() {
			if (this.searchReplace.matches.length === 0) return;

			let prevIndex = this.searchReplace.currentMatchIndex - 1;
			if (prevIndex < 0) {
				prevIndex = this.searchReplace.matches.length - 1; // 循环到最后一个
			}

			this.focusMatch(prevIndex);
		},

		// 替换当前匹配项
		replaceCurrent() {
			if (
				this.searchReplace.matches.length === 0 ||
				this.searchReplace.currentMatchIndex === -1
			)
				return;

			const quill = this.$refs.QuillEditor.quill;
			const currentMatch =
				this.searchReplace.matches[this.searchReplace.currentMatchIndex];

			// 替换文本
			quill.deleteText(currentMatch.index, currentMatch.length);
			quill.insertText(currentMatch.index, this.searchReplace.replaceTerm);

			// 重新搜索
			this.$nextTick(() => {
				this.searchInContent();
			});
		},

		// 替换所有匹配项
		replaceAll() {
			if (this.searchReplace.matches.length === 0) return;

			const quill = this.$refs.QuillEditor.quill;

			// 从后往前替换，避免索引变化影响
			for (let i = this.searchReplace.matches.length - 1; i >= 0; i--) {
				const match = this.searchReplace.matches[i];
				quill.deleteText(match.index, match.length);
				quill.insertText(match.index, this.searchReplace.replaceTerm);
			}

			// 清除搜索状态
			this.clearSearch();
		},

		// 清除搜索高亮
		clearSearchHighlight() {
			const quill = this.$refs.QuillEditor.quill;
			if (quill) {
				const length = quill.getLength();
				quill.formatText(0, length, "background", false);
			}
		},

		// 清除搜索
		clearSearch() {
			this.searchReplace.searchTerm = "";
			this.searchReplace.replaceTerm = "";
			this.searchReplace.matches = [];
			this.searchReplace.currentMatchIndex = -1;
			this.clearSearchHighlight();
		},
	},
};
</script>
<style scoped></style>

<style scoped>
/* 添加到 <style> 部分 */
.search-replace-toolbar {
	padding: 10px;
	background: #f5f5f5;
	border: 1px solid #ddd;
	border-radius: 4px;
}

.search-replace-container {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}

.search-input,
.replace-input {
	padding: 5px 10px;
	border: 1px solid #ccc;
	border-radius: 3px;
	width: 150px;
}

.search-buttons {
	display: flex;
	align-items: center;
	gap: 5px;
}

.search-btn,
.nav-btn,
.replace-btn,
.replace-all-btn,
.clear-btn {
	padding: 5px 10px;
	border: 1px solid #ccc;
	background: white;
	border-radius: 3px;
	cursor: pointer;
}

.search-btn:hover,
.nav-btn:hover,
.replace-btn:hover,
.replace-all-btn:hover,
.clear-btn:hover {
	background: #e6e6e6;
}

.match-count {
	font-size: 12px;
	color: #666;
}

.toolbar-extension {
	margin-bottom: 10px;
}

.toolbar-btn {
	padding: 5px 10px;
	border: 1px solid #ccc;
	background: white;
	border-radius: 3px;
	cursor: pointer;
	font-size: 14px;
}

.toolbar-btn:hover {
	background: #e6e6e6;
}
</style>

<style>
.ql-snow .ql-picker {
	line-height: 24px;
}
.ql-container {
	height: 400px;
	overflow: auto;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
	content: "黑体";
	font-family: "SimHei";
}

.ql-snow
	.ql-picker.ql-font
	.ql-picker-label[data-value="Microsoft-YaHei"]::before,
.ql-snow
	.ql-picker.ql-font
	.ql-picker-item[data-value="Microsoft-YaHei"]::before {
	content: "微软雅黑";
	font-family: "Microsoft YaHei";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
	content: "楷体";
	font-family: "KaiTi";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
	content: "仿宋";
	font-family: "FangSong";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
	content: "Arial";
	font-family: "Arial";
}

.ql-snow
	.ql-picker.ql-font
	.ql-picker-label[data-value="Times-New-Roman"]::before,
.ql-snow
	.ql-picker.ql-font
	.ql-picker-item[data-value="Times-New-Roman"]::before {
	content: "Times New Roman";
	font-family: "Times New Roman";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
	content: "sans-serif";
	font-family: "sans-serif";
}

.ql-font-SimSun {
	font-family: "SimSun";
}

.ql-font-SimHei {
	font-family: "SimHei";
}

.ql-font-Microsoft-YaHei {
	font-family: "Microsoft YaHei";
}

.ql-font-KaiTi {
	font-family: "KaiTi";
}

.ql-font-FangSong {
	font-family: "FangSong";
}

.ql-font-Arial {
	font-family: "Arial";
}

.ql-font-Times-New-Roman {
	font-family: "Times New Roman";
}

.ql-font-sans-serif {
	font-family: "sans-serif";
}

/* 字号设置 */
/* 默认字号 */
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
	content: "14字号";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
	content: "14字号" !important;
	font-size: 14px;
}

.ql-size-14px {
	font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
	content: "16字号";
	font-size: 16px;
}

.ql-size-16px {
	font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
	content: "18字号";
	font-size: 16px;
}

.ql-size-18px {
	font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
	content: "20字号";
	font-size: 16px;
}

.ql-size-20px {
	font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
	content: "22字号";
	font-size: 16px;
}

.ql-size-22px {
	font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
	content: "26字号";
	font-size: 16px;
}

.ql-size-26px {
	font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
	content: "28字号";
	font-size: 16px;
}

.ql-size-28px {
	font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
	content: "30字号";
	font-size: 16px;
}

.ql-size-30px {
	font-size: 16px;
}
.quill-editor {
	margin-left: 0px !important;
}
.ql-container {
	height: 800px;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
	border: 1px solid gray;
	padding: 0px 20px;
}
/* 隐藏滚动条但保持滚动功能 */
.laboratory_editor ::-webkit-scrollbar {
	display: none;
}

.laboratory_editor {
	-ms-overflow-style: none; /* IE 和 Edge 隐藏滚动条 */
	scrollbar-width: none; /* Firefox 隐藏滚动条 */
}

/* 如果需要更具体地针对 quill 编辑器区域 */
.ql-container ::-webkit-scrollbar {
	display: none;
}

.ql-container {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

/* 针对编辑器整体区域 */
.ql-editor ::-webkit-scrollbar {
	display: none;
}

.ql-editor {
	-ms-overflow-style: none;
	scrollbar-width: none;
	padding: 0px 0px;
}
</style>
<style>
@import url(../../../assets/article.css);

/* 修复 ol 样式 */
.ql-container ol {
	padding-left: 1.5em !important; /* 增加左边距 */
	list-style-position: inside !important; /* 确保数字在容器外部 */
}

.ql-container ol li {
	list-style-type: decimal !important;
}
.ql-container {
	height: calc(100% - 100px);
}
.ql-flip {
	left: 0px !important;
}

/* 使用媒体查询或容器查询来处理右侧情况 */
@media (min-width: 768px) {
	.ql-editor .ql-flip {
		left: auto !important;
		right: 0px !important;
	}
}

/* 或者使用更通用的解决方案 */
.ql-container .ql-flip {
	position: absolute !important;
	left: 0px !important;
}

.ql-snow .ql-tooltip {
	width: 400px;
}

.ql-container .ql-flip[style*="right"] {
	left: auto !important;
	right: 0px !important;
}
</style>
